import { shouldValidateOpgavekompleksetInput } from './_inputs.js';

/**
 * A task is only considered as validatable in case it contains at least one
 * input whose shouldValidate() function returns true.
 */
function canValidateOpgavekompleksetTask(task) {
  if (!task) {
    return false;
  }
  const content = task.type === "stack" ? task.tasks.flatMap(it => it.content) : task.content;
  return content.some(it => {
    return shouldValidateOpgavekompleksetInput(it, undefined);
  });
}

export { canValidateOpgavekompleksetTask };
//# sourceMappingURL=util.can-validate-task.js.map
